import React from 'react';
import { DateSelectorWrapper, LabelStyled } from './styled';

export const DateSelectorPerMonth = ({ selectedMonth, selectedYear, setSelectedMonth, setSelectedYear }) => {
  const months = ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'];
  const years = [2023, 2024, 2025, 2026];


  return (
    <DateSelectorWrapper>
      <LabelStyled>
        Miesiąc:
        <select value={selectedMonth} onChange={(e) => setSelectedMonth(Number(e.target.value))}>
          {months.map((month, index) => (
            <option key={index} value={index}>{month}</option>
          ))}
        </select>
      </LabelStyled>
      <LabelStyled>
        Rok:
        <select value={selectedYear} onChange={(e) => setSelectedYear(Number(e.target.value))}>
          {years.map((year) => (
            <option key={year} value={year}>{year}</option>
          ))}
        </select>
      </LabelStyled>
    </DateSelectorWrapper>
  );
};

